export type OrderSearchScope = "all" | "customer" | "items";

const TRACKING_RE = /^(ppx|ox|x)\d{4,}$/i;

/**
 * Guesses what the user meant by a search term so the unified orders search doesn't
 * drown a precise lookup (order number, tracking code, email) in item-name matches.
 * Anything ambiguous stays "all" — the user can always narrow with the scope chips.
 */
export function detectOrderSearchScope(term: string): OrderSearchScope {
  const t = term.trim();
  if (!t) return "all";
  if (TRACKING_RE.test(t)) return "customer";
  if (t.includes("@")) return "customer";
  // Plain digits: an order number or a phone. SKUs in this catalog are never bare digits.
  if (/^\d{3,}$/.test(t.replace(/[\s/-]/g, ""))) return "customer";
  return "all";
}

export const SCOPE_LABELS: Record<OrderSearchScope, string> = {
  all: "Sve",
  customer: "Kupac i broj",
  items: "Artikli",
};

/**
 * A manual scope chip stays in effect while the user refines the same term, but must
 * fall away when they type a different one — otherwise a stale "Artikli" override
 * silently returns zero hits for an order number pasted into the same field.
 */
export function overrideSurvives(prevTerm: string, nextTerm: string): boolean {
  const a = prevTerm.trim().toLowerCase();
  const b = nextTerm.trim().toLowerCase();
  if (!a || !b) return false;
  return a.startsWith(b) || b.startsWith(a);
}
